module.exports = __webpack_public_path__ + "static/media/Owen christensen.b73d3e0a.jpeg";